import { Dialog, DialogContent, DialogTitle, Divider, Grid, TextField } from '@mui/material'

import { PropertyList } from '../../../../../components/PropertyList'
import { PropertyListItem } from '../../../../../components/PropertyListItem'
import ImgTag from '../../../../../components/ImgTag'

interface IFacebookMessageOrderDetailModalProps {
  isMobile: boolean;
  isOpen: boolean;
  onClose: (visible: boolean) => void;
  data?: IFacebookMessageOrder;
}

export interface IFacebookMessageOrder {
  title: string;
  subtitle: string;
  quantity: number;
  price: number;
  currency: string;
  image_url: string;
}

export const FacebookMessageOrderDetailModal = (props: IFacebookMessageOrderDetailModalProps) => {
  const { isMobile, isOpen, onClose, data } = props
  const {
    title = '',
    subtitle = '',
    quantity = 0,
    price = 0,
    currency = '',
    image_url = '',
  } = data || {}

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)} maxWidth="lg">
      <DialogTitle>รายละเอียดสินค้า</DialogTitle>
      <ImgTag
        imageUrl={image_url}
        name={title}
        size={isMobile ? 100 : 150}
      />
      <DialogContent>
        <PropertyList>
          <PropertyListItem
            align={`horizontal`}
            label="ชื่อสินค้า"
            value={title} />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="รายละเอียด"
            value={subtitle}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="จำนวน"
            value={`${quantity} ชิ้น`}
          />
          <Divider />
          <PropertyListItem
            align={`horizontal`}
            label="ราคา"
            value={`${price} ${currency}`}
          />
          <Divider />
        </PropertyList>
      </DialogContent>
    </Dialog>
  )
}
